<template>
  <div id="excel-catalogo-conceptos">
    <custom-button
    :disabled="!showBotonExportar"
      label="Exportar"
      iconText="fa-file-excel"
      tipo="agregar"
      class="mr-2"
      :loading="estaCargando"
      @click="generarExcelOficios"
    >
    </custom-button>
  </div>
</template>

<script>
import mixGenerarExceles from '@/helpers/mixGenerarExcel';
import CustomButton from '@/components/buttons/Button.vue';

// Fila en la que inician los datos con titulos del excel
const filaTitulos = 3;
const filaInicioDatos = filaTitulos + 1;

export default {
  name: 'ExcelCatalogo',
  mixins: [mixGenerarExceles],
  props: {
    ejercicio: {
      type: String,
      required: false,
      default: '',
    },
    listaOficiosAutorizacion: {
      type: Array,
      required: false,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      estaCargando: false,
      configuracionExcel: {},

      // Estilo del header
      estiloHeader: {
        font: {
          bold: true,
        },
        alignment: {
          horizontal: 'center',
          vertical: 'center',
        },
        border: {
          top: {
            style: 'thin',
            color: '000000',
          },
          bottom: {
            style: 'thin',
            color: '000000',
          },
        },
      },
      // Datos de los encabezados que apareceran en el excel.
      headers: [
        {
          value: 'Clave de Obra Planeación',
        },
        {
          value: 'Obra',
        },
        {
          value: 'Importe Autorizado',
        },
        {
          value: 'ClavePresupuestal',
        },
        {
          value: 'Número de Oficio',
        },
        {
          value: 'Fecha de Oficio',
        },
        {
          value: 'Tipo',
        },
        // {
        //   value: 'Contrato',
        // },
      ],
      // Datos de las columnas que aparecerán en el excel.
      columnas: [
        'claveObraPlaneacion',
        'obra',
        'importe',
        'clavePresupuestal',
        'numero',
        'fecha',
        'tipo',
        // 'contrato',
      ],
      noData: [{
        claveObraPlaneacion: '',
        obra: '',
        importe: '',
        clavePresupuestal: '',
        numero: '',
        fecha: '',
        tipo: '',
        // contrato: '',
      }],
      estilos: {
        centrado: {
          alignment: {
            horizontal: 'center',
            vertical: 'center',
          },
        },
        dinero: {
          numberFormat: '$#,##0.00',
        },
      },
    };
  },
  methods: {
    async generarExcelOficios() {
      const data = this.crearExcel;
      await this.mixGenerarExcel(data);
    },
  },
  computed: {
    nombreDocumento() {
      return `OFICIOS-AUTORIZACION-${this.ejercicio}`;
    },
    showBotonExportar() {
      if (this.listaOficiosAutorizacion.length >= 1) { return true; }
      return false;
    },
    crearDatosParaExcel() {
      // const oficios = this.listaOficiosAutorizacion;
      // oficios.sort((a, b) => a.numero - b.numero);
      // return oficios;
      const recursosObras = [];
      this.listaOficiosAutorizacion.forEach((oficioAutorizacion) => {
        oficioAutorizacion.detalles.forEach((detalle) => {
          recursosObras.push({
            claveObraPlaneacion: detalle.obra.clave,
            obra: detalle.obra.meta,
            importe: {
              value: detalle.importe,
              estilo: {
                ...this.estilos.dinero,
              },
            },
            clavePresupuestal: detalle.clavePresupuestal,
            numero: oficioAutorizacion.numero,
            fecha: this.$moment(oficioAutorizacion.fecha).format('DD/MM/YYYY'),
            tipo: oficioAutorizacion.tipo,
            // contrato: '',
          });
        });
      });
      return recursosObras.sort((a, b) => {
        if (a.claveObraPlaneacion !== b.claveObraPlaneacion) {
          return a.claveObraPlaneacion.localeCompare(b.claveObraPlaneacion);
        }
        return new Date(a.fecha) - new Date(b.fecha);
      });
    },

    crearDatosDocumento() {
      return [
        {
          value: `RECURSOS AUTORIZADOS EN OFICIOS DEL EJERCICIO ${this.ejercicio}`,
          row: 1,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
          combinar: {
            row: 1,
            col: 9,
          },
        },

      ];
    },

    crearExcel() {
      const datosExcel = this.crearDatosParaExcel.length > 0
        ? this.crearDatosParaExcel : this.noData;
      const datosDocumento = this.crearDatosDocumento;
      const dataHeaders = this.headers;
      const nombreDeColumnas = [...this.columnas];

      const data = {
        excelData: {
          configuration: this.configuracionExcel,
          header: {
            filaInicio: filaTitulos,
            estilo: this.estiloHeader,
            datosDocumento: [...datosDocumento],
            data: [...dataHeaders],
          },
          body: {
            nombreDeColumnas,
            filaInicio: filaInicioDatos,
            data: [...datosExcel],
          },
        },
      };
      return data;
    },
  },

};
</script>

<style>

</style>
